import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { Fab, Paper, TableCell, TableContainer } from '@mui/material';
import { Carousel } from '../models/Carousel';
import { useTranslation } from 'react-i18next';
import { useLogger } from '../framework/logger';
import TableView from '../framework/ui/view/table';
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { useIsAdmin } from '../atoms';
import { useNavigate } from 'react-router-dom';
import { carouselAll, carouselAtom, carouselRequestNumberState } from '../atoms/carousel';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import excerpts from '../utils/excerpts';
import { useConfirmDialog } from '../components/ConfirmDialog';
import api from '../services/api';

export interface CarouselPageProps {
}

function CarouselPage (props: CarouselPageProps) {
    const { t } = useTranslation()
    const logger = useLogger({ key: 'carouselSearch' })
    const isAdmin = useIsAdmin()
    const navigate = useNavigate()
    const items = useRecoilValue<Carousel[]>(carouselAll)
    const { openConfirm, closeConfirm } = useConfirmDialog()
    const setCarouselRequestNumberState = useSetRecoilState<number>(carouselRequestNumberState)
    const [ , setCarousel] = useRecoilState(carouselAtom)
    const resetCarousel = useResetRecoilState(carouselAtom)
    
    const handleAddCarousel = (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        resetCarousel()
        navigate('/adm/carousel/0');
    }
    
    const handleEditCarousel = (item: Carousel) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        console.log('carousel in Edit', item)
        //Lo imposto nello stato globale
        setCarousel(item)
        navigate('/adm/carousel/' + item.id);
    }

    const handleDeleteCarousel = (item: Carousel) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        if (!isAdmin) {
            logger.warning(t('Non hai i diritti per eseguire l\'operazione'))
            return
        }
        
        openConfirm({
            title: t('Cancellazione carousel'),
            prompt: t('Elimino il carousel item?'),
            cancelText: t('Annulla'),
            confirmText: t('Cancella'),
            cancel: () => closeConfirm(),
            confirm: () => {
                api.deleteCarousel(item.id).then(() => {
                    setCarouselRequestNumberState(r => r + 1)
                    console.log('Cancellazione Effettuata')
                }).then(() => setTimeout(() => closeConfirm(), 100))
                console.log('Confirm closed')
            },
            onClose: () => closeConfirm(),
            children: (
                <>
                    <Typography component='div' sx={{ mb: 0.5, fontWeight: 'bold' }} variant='body1'>{item.title}</Typography>
                    <Typography component='div' sx={{ mb: 2 }} variant='body2'>{item.argument}</Typography>
                </>
            )
        })
    }
        
    return (
        <Box sx={{ width: '90%', mb: 1, mt: 1, px: 2, pt: 1 }}>
            <Paper>

            </Paper>
            <TableContainer sx={{position: 'relative'}}>
                <Fab size="small" color="primary" sx={{ position: 'absolute', top: 8, right: 8, zIndex: 3 }} onClick={handleAddCarousel}><AddIcon /></Fab>
                <TableView
                    items={items}
                    itemKey={(item: Carousel) => item.id}
                    thDefs={<>
                        <TableCell><Typography color='primary'>{t('Titolo')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Solo immagine')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Payload')}</Typography></TableCell>
                        <TableCell><Typography color='primary'>{t('Ordinamento')}</Typography></TableCell>
                        <TableCell >
                            <Typography color='primary'>{t('Azioni')}</Typography>
                        </TableCell>
                    </>}
                    trDefs={(row: Carousel) => (<>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.imageOnly ? 'YES' : 'NO'}</TableCell>
                        <TableCell style={{maxWidth: '550px'}}>{excerpts(row.payload, { words: 40 })}</TableCell>
                        <TableCell>{row.ordering}</TableCell>
                        <TableCell >
                            <Box sx={{display: 'flex', gap: 0.5, cursor: 'pointer', textAlign: 'center', height: '100%', pt: '6px', pb: 0}}>
                                <Box onClick={handleDeleteCarousel(row)} sx={{width: 20, height: 20}}> 
                                    <DeleteIcon fontSize='small' titleAccess={t('Elimina')} color='primary' />
                                </Box>
                                <Box onClick={handleEditCarousel(row)} sx={{width: 20, height: 20}}> 
                                    <EditIcon fontSize='small' titleAccess={t('Modifica')} color='primary' />
                                </Box>
                            </Box>
                        </TableCell>
                    </>)}
                />
            </TableContainer>
        </Box>
    );
}

export default CarouselPage;